import React from "react";

import OldFollowupForm from "Portal/FollowupForm/View";
import NewFollowupForm from "Portal/NewPortal/FollowupForm/View";

const FollowupFormRouter = ({ ...props }) => {
  const { params } = props || {};
  const { enabledNewPortal = "false" } = params || {};
  const Component =
    enabledNewPortal === "true" ? NewFollowupForm : OldFollowupForm;
  return <Component {...props} enableNewPortal={enabledNewPortal} />;
};

export default FollowupFormRouter;
